import { render, staticRenderFns } from "./preliminaryBusinessHandling.vue?vue&type=template&id=066bcbb5&scoped=true&"
import script from "./preliminaryBusinessHandling.vue?vue&type=script&lang=js&"
export * from "./preliminaryBusinessHandling.vue?vue&type=script&lang=js&"
import style0 from "./preliminaryBusinessHandling.vue?vue&type=style&index=0&id=066bcbb5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066bcbb5",
  null
  
)

export default component.exports